import React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Navbar from './features/navbar/Navbar';
import Footer from './features/footer/Footer';
import theme from './theme';
import UtmCampaignTracker from './components/Utils/UtmCampaignTracker';
import HotjarProvider from './components/Utils/HotjarProvider';
import ScrollToTop from './components/animations/ScrollToTop';
import TrackerProvider from './components/Utils/TrackerProvider';
import Home from './features/home/Home';
import Team from './features/team/Team';
import Factoring from './features/products/Factoring';
import Ordering from './features/products/Ordering';
import Confirming from './features/products/Confirming';
import ProntoPago from './features/products/ProntoPago';
import KoBros from './features/products/KoBros';
import HelpComplianceInfo from './features/legal/HelpComplianceInfo';
import Terms from './features/legal/Terms';
import FAQ from './features/faq/FAQ';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <HotjarProvider>
          <Router>
            <TrackerProvider>
              <UtmCampaignTracker>
                <ScrollToTop />
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/factoring" element={<Factoring />} />
                  <Route path="/factoraje" element={<Factoring />} />
                  <Route path="/ordering" element={<Ordering />} />
                  <Route path="/confirming" element={<Confirming />} />
                  <Route path="/pronto-pago" element={<ProntoPago />} />
                  <Route path="/kobros" element={<KoBros />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/help/:type" element={<HelpComplianceInfo />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Footer />
              </UtmCampaignTracker>
            </TrackerProvider>
          </Router>
        </HotjarProvider>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
